import {css} from 'emotion'

export const TrainingStyle = css({
  height: 'calc(100vh - 80px)',
  '.videos-template': {
    height: '100%',
    '.video-container-full': {
      height: 'calc(100% - 80px)',
    }
  },
  
})


// WEBPACK FOOTER //
// ./src/styles/containers/training.js